module.exports = __webpack_public_path__ + "static/Messaging 2-de4a9c3b2a27f173331d661c24d7d6da.png";